import { useEffect, useState } from "preact/hooks";
import { pick } from "@nosto/search-js/utils";
import DynamicProduct from "@/components/Product/DynamicCardProduct";
import {
  useDecoratedSearchResults,
  useNostoAppState,
} from "@nosto/search-js/preact/hooks";
import { useDisruptors } from "@/hooks/useDisruptors";
import { cl } from "@nosto/search-js/utils";
import { hitDecorators } from "@/config";
import { SearchTrackOptions } from "@nosto/nosto-js/client";

export default function Products({
  searchTrackType,
}: {
  searchTrackType: SearchTrackOptions;
}) {
  const [altered, setAltered] = useState<boolean>(false);
  const { loading } = useNostoAppState((state) => pick(state, "loading"));
  const { query } = useNostoAppState((state) => pick(state, "query"));
  const { products } = useDecoratedSearchResults<typeof hitDecorators>();

  useDisruptors([products, loading]);

  useEffect(() => {
    const isFirstPage = !query.products?.from || query.products.from === 0;
    const isFiltered =
      query.products?.filter && query.products.filter.length > 0;
    const isSorted = query.products?.sort && query.products.sort.length > 0;

    if (!isFirstPage || isFiltered || isSorted) {
      setAltered(true);
    } else {
      setAltered(false);
    }
  }, [products, query]);

  return (
    <div
      className={cl(
        "plp__grid",
        loading && "plp__grid--is-loading",
        altered && "plp__grid--altered",
      )}
    >
      {!loading &&
        products.hits.map((hit, index) => (
          <div className="plp__grid-item" key={hit.productId}>
            <DynamicProduct
              product={hit}
              index={index}
              searchTrackType={searchTrackType}
            />
          </div>
        ))}
    </div>
  );
}
